import BreadCrumb from "../common/breadcrumb";
import SEO from "../../data/seo";
import HeaderTwo from "../../layout/headers/header-two";
import AboutMain from "./about";
import Certification from "./certification";
import FooterOne from "../../layout/footers/footer-one";

const AboutUs = () => {
    return (
        <>
            <SEO pageTitle="About Us" />
            <HeaderTwo />
            <BreadCrumb title="About Us" innerTitle="About Us" />
            <AboutMain />
            <Certification />
            <FooterOne />
        </>
    );
};

export default AboutUs;